import { BaseApi } from "./base";
import { GAME_APP, GAME_CONFIG } from "../enums/modules/game";

const apiUrl = "/gameclient/";

export const GameServiceAPI = {
  getUserInfo(params) {
    return BaseApi.request(
      "querySerialize",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL + apiUrl + "game-turns",
      params
    );
  },

  getGame(params) {
    return BaseApi.request(
      "querySerialize",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL + apiUrl + "get-game/" + GAME_APP.ID,
      params
    );
  },

  getGifts(params) {
    return BaseApi.request(
      "querySerialize",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL +
        "/gameclient/common/list-game-rewards",
      params
    );
  },

  history(params) {
    return BaseApi.request(
      "querySerialize",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL +
        apiUrl +
        "common/list-customer-rewards",
      params
    );
  },

  drawGift(params) {
    return BaseApi.request(
      "post",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL + apiUrl + "common/games-start",
      params
    );
  },

  retryGift(params) {
    return BaseApi.request(
      "querySerialize",
      process.env.VUE_APP_CASH_POINT_URL + apiUrl + "customer-rewards/retry",
      params
    );
  },

  insertAddress(params) {
    return BaseApi.request(
      "put",
      GAME_CONFIG.VUE_APP_GAME_SERVICE_URL + apiUrl + "cart-address/update",
      params
    );
  },
};
